import { JourneyInterface, QuestInterface, Slug } from "@swivl-mono/types";
import { FormFieldWidth, LabelPosition, Select, SelectItem, SelectableOption } from "@swivl-mono/ui";

import { useQuestOptions } from "../../../Hooks/useQuestOptions";
import { WorkflowsJourney } from "../../../Models/Quests/Quests.Model";

interface Props {
  value?: any;
  name?: string;
  label?: string;
  labelPosition?: LabelPosition;
  prependOptions?: SelectableOption[];
  stayAtTopOnOpen?: boolean;
  questSelected?(slug: Slug, name?: string): void;
  onClear?(): void;
  onChange?(selected: string[]): void;
  optionSelected?(option: SelectableOption, name?: string): void;
  disableEditing?: boolean;
  filterJourney?(journey: JourneyInterface): boolean;
  filterQuest?(quest: QuestInterface): boolean;
  width?: FormFieldWidth;
}

export function QuestOptions(
  workflows: WorkflowsJourney[],
  prependOptions?: SelectableOption[],
  filterJourney?: (journey: JourneyInterface) => boolean,
  filterQuest?: (quest: QuestInterface) => boolean
): SelectableOption[] {
  let questOptions: SelectableOption[] = [];

  if (workflows) {
    for (var i = 0; i < workflows.length; i++) {
      if (workflows[i].quests.length == 0) continue;
      if (filterJourney && !filterJourney(workflows[i]!.journey!)) continue;

      const journeyQuests: SelectableOption[] = [];

      for (var q = 0; q < workflows[i].quests.length; q++) {
        const quest = workflows[i].quests[q];
        if (filterQuest && !filterQuest(quest)) continue;
        journeyQuests.push({ value: quest.slug, label: quest?.name });
      }

      if (journeyQuests.length > 0) {
        questOptions.push({ isHeading: true, label: workflows[i].journey?.name || "Unassigned" });
        questOptions.push(...journeyQuests);
      }
    }
  }
  questOptions = prependOptions ? prependOptions.concat(questOptions) : questOptions;
  return questOptions;
}

export function QuestsDropdown(props: Props) {
  const {
    value,
    prependOptions,
    label,
    labelPosition,
    name,
    stayAtTopOnOpen,
    questSelected,
    onChange,
    onClear,
    optionSelected,
    disableEditing,
    width
  } = props;
  const questOptions = useQuestOptions(prependOptions, props.filterJourney, props.filterQuest, "dropdown");

  const handleChange = (selected: string[]): void => {
    if (selected.length > 0) {
      const selectedOption = (questOptions || []).find((option) => option.value === selected[0]);
      if (selectedOption) {
        if (optionSelected) {
          optionSelected(selectedOption, name);
        }
        if (questSelected) {
          questSelected(selectedOption.value, name);
        }
      }
    } else {
      if (onClear) {
        onClear();
      }
    }
    if (onChange) {
      onChange(selected);
    }
  };

  return (
    <Select
      options={(questOptions || []).filter((option) => option.value !== undefined) as SelectItem[]}
      name={name}
      label={label}
      labelPosition={labelPosition}
      selectedValues={value == null || value === "" ? [] : Array.isArray(value) ? value : [value]}
      hasSearchInDropdown
      onChange={handleChange}
      width={width}
      disabled={disableEditing}
    />
  );
}
